export const FIXED_GLANCE_KEY = {
  VIDEO_COUNT: 'video count',
  LIFE_TIME_LEARN: 'life time learn',
  ATTACHMENT_FILE_COUNT: 'attachment file count',
  ARTICLE_COUNT: 'article count',
  CERTIFICATE: 'certificate',
  QUIZ_COUNT: 'quiz count',
  ASSIGNMENT_COUNT: 'assignment count',
  EXAMINATION_COUNT: 'examination count',
  MASTER_DEGREE: 'master degree',
  TOTAL_COURSES: 'total courses',
};

export const MAX_LINE_DISCUSSION = 5;

export const courseTitleBrowser = (courseName: string) => `${courseName} | คอร์สออนไลน์ | SkillLane`;
